import React from "react";
import icon from "../../assets/Pancake.svg";

export default function PancakeIcon({ size }) {
  return <img src={icon} width={size} />;
}
